var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:map-point-broken"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33279 4.6939C7.91462 4.62333 7.48484 4.68752 7.10553 4.87718C6.72623 5.06685 6.41703 5.37217 6.22259 5.74906C6.02816 6.12594 5.95856 6.55487 6.02384 6.9739C6.08913 7.39293 6.28592 7.78036 6.58579 8.08023C6.88566 8.3801 7.27309 8.57689 7.69212 8.64218C8.11115 8.70746 8.54008 8.63786 8.91696 8.44343C9.29385 8.24899 9.59917 7.93979 9.78884 7.56049C9.9785 7.18118 10.0427 6.7514 9.97212 6.33323",
    stroke: "#285430",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.33268 10.1437C2.90135 9.04101 2.66602 7.86701 2.66602 6.76167C2.66602 3.76367 5.05402 1.33301 7.99935 1.33301C10.9447 1.33301 13.3327 3.76367 13.3327 6.76167C13.3327 9.73634 11.6307 13.2083 8.97468 14.449C8.6694 14.592 8.33644 14.666 7.99935 14.666C7.66226 14.666 7.32929 14.592 7.02402 14.449C6.17602 14.053 5.42468 13.429 4.79535 12.6663",
    stroke: "#285430",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.beaacbe28c541e5740d46166f98c1b35.svg";
export { ForwardRef as ReactComponent };